export default __webpack_public_path__ + "assets/thermometer-glass-celsius.affa308c.svg";